import { columnSettings } from "./report-template-setting";
import { format } from "date-fns";

const settings = {};
for (let columnSetting of columnSettings) {
  settings[columnSetting.field] = columnSetting;
}

const ReportTemplateDetail = (props) => {
  const {
    mykey,
    no,
    tanggal,
    durasi,
    label_grup,
    keterangan,
    nama_transport,
    nama_keamanan,
    nama_supir,
    tipe,
    note,
  } = props;

  const hasDetail = (tipe, keamanan, supir, transport) =>
    [tipe, keamanan, supir, transport].some(v => v && v !== "-");

  return (
    <>
      <tr
        key={mykey}
        className="row-start-start w-full text-sm text-slate-700 !items-stretch"
      >
        <td
          className={`${settings["no"].layout} ${settings["no"].width} border-zinc-300 border border-t-0  px-2 pt-2 pb-1 `}
        >
          {no}
        </td>

        <td
          className={`${settings["tanggal"].layout} ${settings["tanggal"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
        >
          {tanggal
            ? format(new Date(tanggal), settings["tanggal"].format)
            : "-"}
        </td>

        <td
          className={`${settings["durasi"].layout} ${settings["durasi"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
        >
          {durasi ? durasi.toLocaleString("id-ID") : "-"}
        </td>

        <td
          className={`${settings["label_grup"].layout} ${settings["label_grup"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
        >
          {label_grup}
        </td>

        <td
          className={`${settings["keterangan"].layout} ${settings["keterangan"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
        >
          {keterangan + (note ? ", " + note : "")}
        </td>
      </tr>
      {hasDetail(tipe, nama_keamanan, nama_supir, nama_transport) && (
        <tr
          key={`${mykey}-second-line`}
          className="row-start-start w-full text-sm text-slate-700 !items-stretch"
        >
          <td
            className={`${settings["no"].layout} ${settings["no"].width} border-zinc-300 border border-t-0  px-2 pt-2 pb-1 `}
          ></td>

          <td
            className={`row-start-center grow border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 gap-4`}
            colSpan={4}
          >
            {tipe && <span className="font-semibold">{tipe}</span>}

            {nama_keamanan && (
              <div className="row-start-center gap-2 text-xs italic">
                <span>Keamanan:</span>
                <span className="text-slate-800">{nama_keamanan}</span>
              </div>
            )}
            {nama_supir && (
              <div className="row-start-center gap-2 text-xs italic">
                <span>Supir:</span>
                <span className="text-slate-800">{nama_supir}</span>
              </div>
            )}
            {nama_transport && (
              <div className="row-start-center gap-2 text-xs italic">
                <span>Transport:</span>
                <span className="text-slate-800">{nama_transport}</span>
              </div>
            )}
          </td>
        </tr>
      )}
    </>
  );
};

export default ReportTemplateDetail;
